/*
    接口配置列表
*/

const interfaceList = {

}

export default interfaceList;



// WEBPACK FOOTER //
// ./src/utils/interface-list/interface-list.js